import { Header, Text, MCIcon } from "@src/components"
import { ar } from "@src/i18n/ar"
import { OrderForm } from "@src/components/order-form"
import { useLocalSearchParams } from "expo-router"
import { trpc, isOrderEditable } from "@src/utils"
import { View, ActivityIndicator } from "react-native"

export default function EditOrder() {
  const params = useLocalSearchParams<{ id: string }>()
  const orderId = Number.parseInt(params?.id, 10)

  const order = trpc.orders.get.useQuery({ id: orderId })
  const products = trpc.products.getMultiple.useQuery({ ids: order.data?.items.map((i) => i.productId) ?? [] })
  const customer = trpc.customers.get.useQuery({ id: order.data?.customerId as number }, { enabled: order.data?.customerId !== undefined })

  if (order.isLoading || customer.isLoading || products.isLoading) {
    return (
      <>
        <Header title={ar.editOrder} />
        <View className="flex-1 justify-center items-center">
          <ActivityIndicator size="large" color="#3b82f6" />
        </View>
      </>
    )
  }

  if (!order.data) {
    return (
      <>
        <Header title={ar.editOrder} />
        <View className="flex-1 justify-center items-center p-4">
          <MCIcon name="alert-circle" size={64} color="#ef4444" />
          <Text className="text-lg text-gray-700 mt-4">{ar.error}</Text>
        </View>
      </>
    )
  }

  const canEdit = isOrderEditable(order.data.status)
  if (!canEdit) {
    return (
      <>
        <Header title={ar.editOrder} />
        <View className="flex-1 justify-center items-center p-4">
          <MCIcon name="lock" size={64} color="#6b7280" />
          <Text className="text-lg text-gray-700 mt-4 text-center">{ar.cannotEditOrder}</Text>
          <Text className="text-sm text-gray-500 mt-2 text-center">{ar.orderMustBePendingOrConfirmed}</Text>
        </View>
      </>
    )
  }

  return (
    <>
      <Header title={`${ar.editOrder} #${order.data.orderNumber}`} />
      <OrderForm orderId={orderId} />
    </>
  )
}
